import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
}
const Card = ({
  children,
  className = ''
}: CardProps) => {
  return <div className={`bg-white rounded-xl shadow-md p-4 ${className}`} data-id="element-20">
      {children}
    </div>;
};
export default Card;